// extracted by mini-css-extract-plugin
export default {"wrapper":"ErrorMessage_wrapper__EOldx"};